import { legacyAddInvite } from 'src/api/node/requests'
import {
  SEND_INVITE_REQUEST,
  SEND_INVITE_SUCCESS,
  SEND_INVITE_FAILURE
} from './actionTypes'
import { selectUserLegacyId } from 'src/store/selectors/layout'
import { selectCustomerProfile } from 'src/store/selectors/customerProfile'
import { flashNotification } from 'src/actions/notification'
import { SHARE, ERRORS } from 'src/constants/messages'

export const sendInvite = ({ firstName, lastName, email }) => async (
  dispatch,
  getState
) => {
  const state = getState()

  const agentId = (selectCustomerProfile(state) || {}).legacyRef
  const inviterId = selectUserLegacyId(state)

  dispatch({
    type: SEND_INVITE_REQUEST
  })

  try {
    await legacyAddInvite({
      agentId,
      email,
      firstName,
      inviterId,
      lastName
    })
    dispatch({
      type: SEND_INVITE_SUCCESS
    })
    dispatch(
      flashNotification({
        message: SHARE.success,
        messageType: 'success'
      })
    )
  } catch (error) {
    dispatch({
      type: SEND_INVITE_FAILURE,
      error
    })

    dispatch(
      flashNotification({
        message: [ERRORS.defaultHeadline, ERRORS.defaultMessage],
        messageType: 'error'
      })
    )
  }
}
